document.querySelector('.close-drawer span').addEventListener('click', function() {
    const menuButton = document.querySelector('.header__icon--menu[aria-expanded="true"]');
    const menuDrawer = document.querySelectorAll('.custom-menu-drawer');
    if (menuButton) {
        menuButton.click(); // Simulating a click event
    }
});


document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll(".testimonials-slider");
  sliders.forEach(function (slider) {
    new Flickity(slider, {
      cellAlign: "center",
      adaptiveHeight: true,
      avoidReflow: true,
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: 3000
    });
  });
});



document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-btn');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const wrapper = this.closest('.custom-tabs');

      wrapper.querySelectorAll('.tab-btn').forEach(btn => {
        btn.classList.remove('active');
      });

      wrapper.querySelectorAll('.tab-content').forEach(content => {
        content.classList.remove('active');
      });

      this.classList.add('active');

      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
      }
    });
  });
}); 


